"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ReviewCard;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reviewCardModule = _interopRequireDefault(require("./reviewCard.module.scss"));
var _quote = _interopRequireDefault(require("../../../assets/icons/quote.svg"));
var _imageWrapper = _interopRequireDefault(require("../../imageWrapper/imageWrapper"));
var _useEnhancedHref = _interopRequireDefault(require("../../../hooks/useEnhancedHref"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ReviewCard(props) {
  var hasImage = props.image || props.imageReference;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "review-card",
    className: (0, _classnames["default"])(_reviewCardModule["default"].reviewCard, [_defineProperty({}, _reviewCardModule["default"].hasAuthorImage, props.image && (props.type === 'expert' || props.type === 'person'))]),
    children: [hasImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: props.imageReference ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_imageWrapper["default"], {
        className: (0, _classnames["default"])(_reviewCardModule["default"].image, _defineProperty({}, _reviewCardModule["default"].authorImage, props.type === 'expert' || props.type === 'person')),
        altText: props.imageReference.altText,
        desktop: props.imageReference.desktop,
        tablet: props.imageReference.tablet,
        mobile: props.imageReference.mobile
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: (0, _classnames["default"])(_reviewCardModule["default"].image, _defineProperty({}, _reviewCardModule["default"].authorImage, props.type === 'expert' || props.type === 'person')),
        alt: props.imageAltText,
        src: props.image
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _quote["default"],
      role: "presentation"
    }), props.type === 'expert' && /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
      children: "John Lewis Expert Says"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _reviewCardModule["default"].copy,
      children: ["\u201C", props.copy, "\u201D"]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _reviewCardModule["default"].author,
      children: props.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: (0, _useEnhancedHref["default"])(props.url),
        children: props.author
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: props.author
      })
    })]
  });
}